import React, { useEffect } from 'react';
import { FlagProvider, useUnleashContext } from '@unleash/proxy-client-react';
import { useSelector } from 'react-redux';
import { selectPrivyToken } from '../../redux/slices/auth.js';
import { useGetCurrentUserProfileQuery } from '../../redux/api/authorized/auth.js';

const defaultConfig = {
  url: 'https://us.app.unleash-hosted.com/usdd0004/api/frontend/',
  clientKey: import.meta.env.VITE_UNLEASH_TOKEN,
  appName: 'unleash-onboarding-react',
  context: {
    properties: {
      userId: 'anonymous',
    },
  },
};

const UnleashContext = ({ children }) => {
  const privyToken = useSelector(selectPrivyToken);
  const { data, isLoading } = useGetCurrentUserProfileQuery(undefined, {
    skip: !privyToken,
  });

  const updateContext = useUnleashContext();

  useEffect(() => {
    async function updateUserContext() {
      if (data?.id && !isLoading) {
        await updateContext({ userId: data.id.toString() });
      }
    }
    updateUserContext();
  }, [data?.id, isLoading, updateContext]);

  return children;
};

const UnleashProvider = ({ children }) => {
  return (
    <FlagProvider config={defaultConfig}>
      <UnleashContext>{children}</UnleashContext>
    </FlagProvider>
  );
};

export default UnleashProvider;
